<template>
  <v-container fluid class="pa-4">
    <store-sub-header />
    <v-card class="mx-auto my-4" max-width="600">
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-if="showCountryCode"
              v-model="selectedCountryCode"
              :items="countryCodes"
              label="Country Code"
              class="mb-4"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              class="mt-0"
              name="phone_number"
              :label="$vuetify.t('$vuetify.common.mobileNumber')"
              v-model="telephone"
              :error-messages="phoneNumberErrors"
              ref="txtPhoneNumber"
              mask="NNNNNNNNNN"
              return-masked-value
              type="text"
              autocomplete="tel"
              @blur="validatePhoneOnBlur"
            ></v-text-field>
            <div class="disclaimer">
              {{ $vuetify.t('$vuetify.common.disclaimer.register') }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions style="padding: 10px; padding-bottom: 20px;" class="d-flex justify-end">
        <v-btn :disabled="isRegisterLoading" :loading="isRegisterLoading" color="primary" @click="onRegister">{{ buttonTitle }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import get from 'lodash/get';
import StoreSubHeader from '@/components/StoreSubHeader.vue'
import Cart from '@/components/Cart.vue'
import PopupModal from '@/views/PopupModal.vue'

export default {
  name: 'Register',
  components: {
    StoreSubHeader,
    Cart,
    PopupModal
  },
  data() {
    return {
      title: 'Member Registration',
      telephone: '',
      showCountryCode: false,
      countryCodes: [],
      selectedCountryCode: '',
      phoneNumberErrors: [],
      buttonTitle: 'Register',
      isRegisterLoading: false
    };
  },

  computed: {
    ...mapGetters([
      'getStore'
    ])
  },
  created() {
    this.loadCountryCodes();
  },
  methods: {
    loadCountryCodes() {
      const allowedAreaCodes = get(this.getStore, 'features.allowedInternationAreaCodes', []);
      if (allowedAreaCodes && allowedAreaCodes.length > 0) {
        this.showCountryCode = allowedAreaCodes.length > 1;
        this.countryCodes = allowedAreaCodes.map(code => `+${code}`);
        this.selectedCountryCode = this.countryCodes[0];
      }
    },
    validatePhoneOnBlur() {
      this.validatePhone(this.telephone.replace(/\D/g, ''));
    },
    validatePhone(input) {
      this.phoneNumberErrors = [];
      if (!input) {
        this.phoneNumberErrors.push('Phone number is required.');
        return false;
      }
      const strippedNumber = input.replace(/\D/g, '');
      if (!this.validatePhoneLength(strippedNumber)) {
        this.phoneNumberErrors.push('Invalid phone number length.');
        return false;
      }
      return true;
    },
    validatePhoneLength(strippedNumber) {
      return this.selectedCountryCode === '+86' ? strippedNumber.length === 13 : strippedNumber.length === 10;
    },
    async onRegister() {
      const tel = this.telephone.replace(/\D/g, '');
      this.phoneNumberErrors = [];

      if (!this.validatePhone(tel)) {
        return;
      }

      this.isRegisterLoading = true;
      const data = {
        telephone: tel,
        memberAttributes: {}
      };
      try {
        const baseUrl = process.env.VUE_APP_API;
        const url = `${baseUrl.replace('/owa', '/rwa')}/membership/register`;
        const response = await this.$api.post(url, data);
        this.isRegisterLoading = false;
        this.$store.dispatch('showSnack', {
          text: 'Member registration successful.',
          color: 'success'
        });
        const { gid, sid, mid } = this.$route.params;
        this.$router.push({
          name: 'store',
          params: {
            gid,
            sid,
            mid,
            restaurantSlug: this.getStore.slug
          }
        });
      } catch (error) {
        this.isRegisterLoading = false;
        const errorMsg = error.response && error.response.data && error.response.data.errorMsg
          ? error.response.data.errorMsg
          : 'An error occurred';
        
        this.$store.dispatch('showSnack', {
          text: errorMsg,
          color: 'error'
        });
      } 
    }
  }
};
</script>

<style scoped>
.v-card {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.headline {
  font-weight: 500;
}
.mb-4 {
  margin-bottom: 16px;
}
.disclaimer {
  margin-top: 5px;
  font-size: 0.875rem;
  text-align: left;
}
</style>
